import getDeviceInfos from './getDeviceInfos.js';

export default class DeviceManager {
    constructor(opts = {}) {
        this._html = document.documentElement;
        const infos = getDeviceInfos(opts.userAgent);
        Object.assign(this, infos);
        this._addClasses();
    }


    updateQuality(quality) {
        if (!this.gpu) return;
        this.gpu.qualityIndex = quality;
        const qualities = this.gpu.qualities;
        for (const k in qualities) {
            this._html.classList.toggle(qualities[k], quality == k);
        }
    }


    _addClasses() {
        const html = this._html;
        if (this.hasTouch) html.classList.add('touch');
        for (const type in this.type) {
            if (this.type[type]) html.classList.add(type.toLowerCase());
        }
        if (this.browser && this.browser.length > 0) {
            html.classList.add(this.browser.toLowerCase());
        }
        if (this.os && this.os.length > 0 && this.os !== 'unknown') {
            html.classList.add(this.os.toLowerCase());
        }
    }
}
